import type { TFunction } from 'i18next';
import { ApiRequestError } from './api';

/**
 * Traduit une erreur d'API en message affichable.
 * Le serveur renvoie déjà un message localisé ; on privilégie néanmoins le
 * libellé du catalogue front pour rester cohérent avec la terminologie produit.
 */
export function errorMessage(error: unknown, t: TFunction): string {
  if (error instanceof ApiRequestError) {
    const key = `errors:${error.code}`;
    const translated = t(key, { defaultValue: '' });
    if (translated) return translated;
    return error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return t('common:states.errorTitle');
}

export function errorTraceId(error: unknown): string | undefined {
  return error instanceof ApiRequestError ? error.traceId : undefined;
}

/** Vrai lorsque l'erreur doit conduire à la page « Accès refusé ». */
export function isForbidden(error: unknown): boolean {
  return error instanceof ApiRequestError && error.isForbidden;
}
